import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue } from '../../runtime.js';
import { sockOut } from '../../sockets.js';

const nanDef = {
  type: FgBlockType.NaN,
  build: () => ({
    dataOut: [sockOut("value", FgType.Number)]
  }),
  updateOutputs(block, ctx) {
    setDataValue(ctx, block, "value", Number.NaN);
  }
};

export { nanDef };
//# sourceMappingURL=constant-nan.js.map
